<template>
  <div class="p-4 overflow-hidden">
    <div class="pb-3">
      <h6 class="font-weight-bold">
        {{ current_cycle.date }}
      </h6>
      <div class="d-flex pb-1">
        <div class="divisor ml-1" />
        <div class="font-weight-bold content py-0 pl-3">
          <div v-if="!current_cycle.is_finished">
            <p class="mb-0">
              Ciclo atual: {{ current_cycle.cycle_name }} 
            </p>
            <p class="text-gray-400 mb-0">
              {{ current_cycle.begin | moment('DD/MM/YYYY') }} - {{ current_cycle.end | moment('DD/MM/YYYY') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <v-skeleton-loader
      v-show="isLoadingCalendar"
      type="list-item-three-line"
    />
    <div
      v-for="event in events"
      v-show="!isLoadingCalendar"
      :key="event.id"
      class="pb-3 text-gray-400"
      transition="fade-transition"
    >
      <p
        class="font-weight-bold h6 mb-1 text-gray-400"
      >
        <i class="fa fa-calendar" /> {{ event.dateTitle }} 
      </p>
      <div class="d-flex pb-1">
        <div class="divisor ml-1" />
        <div
          class="font-weight-bold content py-0 pl-3  text-gray-400"
        >
          <p
            class="mb-0 font-weight-bold text-gray-400"
          >
            {{ event.title }}
          </p>
          <p
            v-if="event.type != 'cycle'"
            class="mb-0 font-weight-medium text-gray-400"
          >
            {{ event.description }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="current_cycle.is_finished && events.length == 0 && !isLoadingCalendar">
      <p>
        Não há eventos nesta semana
      </p>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  props: {
    period: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['current_cycle','events','isLoadingCalendar']),
  },
  mounted() {
      this.getEvents(`&period=${this.period}`);
  },
  methods: {
    ...mapActions(['getEvents'])
  }
}
</script>
<style scoped>
.divisor {
  width: 5px;
  border-radius: 5px;
  background-color: var(--gray-400);
}
.content {
  line-height: normal;
}
</style>
